import { render, staticRenderFns } from "./Condominiums.vue?vue&type=template&id=7ab1732e&scoped=true&lang=pug&"
import script from "./Condominiums.vue?vue&type=script&lang=ts&"
export * from "./Condominiums.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab1732e",
  null
  
)

export default component.exports